import * as React from 'react';
import { ArrowRight, BusFront } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { ScheduleResults } from './components/ScheduleResults';
import { useScheduleData, useScheduleDataActions } from './state';

export function ArrivalPage() {
  const snapshot = useScheduleData((value) => value);
  const actions = useScheduleDataActions();
  React.useEffect(() => {
    actions.loadView();
  }, []);
  const loading = snapshot.matches('loading') || snapshot.matches('refreshing');
  const error = snapshot.matches('error');
  return (
    <main className="mx-auto flex w-full max-w-4xl flex-col items-center px-5 py-12 text-center sm:py-20">
      <div className="mb-8 flex size-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-lg shadow-primary/15">
        <BusFront className="size-7" />
      </div>
      <h1 className="max-w-2xl font-heading text-4xl font-semibold tracking-[-0.035em] text-foreground sm:text-6xl">
        Seattle Bus Times
      </h1>
      <p className="mt-5 max-w-xl text-base leading-7 text-muted-foreground sm:text-lg">
        Scheduled — not real-time — departures for RapidRide E Line and Route 44, documented for the stops you use.
      </p>
      <Link to="/scheduled-buses" className="mt-7" data-jr-key="arrival-choose-stop">
        <Button data-jr-key="arrival-choose-stop">
          Choose a stop <ArrowRight className="size-4" />
        </Button>
      </Link>
      <div className="mt-14 w-full text-left">
        <div className="mb-4 flex items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-xl font-semibold">Next documented departures</h2>
            <p className="mt-1 text-sm text-muted-foreground">Choose a stop to narrow this schedule.</p>
          </div>
          <Link to="/scheduled-buses" className="text-sm font-medium text-primary underline-offset-4 hover:underline">
            Full schedule
          </Link>
        </div>
        <ScheduleResults
          entries={snapshot.context.entries}
          lastUpdatedAt={snapshot.context.lastUpdatedAt}
          loading={loading}
          error={error}
          onRetry={actions.refresh}
          compact
        />
      </div>
    </main>
  );
}
